"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CubeClientIds = exports.CubeDataSource = void 0;
var CubeDataSource;
(function (CubeDataSource) {
    CubeDataSource["Presto"] = "prestodb";
    CubeDataSource["Druid"] = "druid";
})(CubeDataSource || (exports.CubeDataSource = CubeDataSource = {}));
var CubeClientIds;
(function (CubeClientIds) {
    CubeClientIds["OwnFleet"] = "own-fleet";
    CubeClientIds["DeliveryHub"] = "delivery-hub";
})(CubeClientIds || (exports.CubeClientIds = CubeClientIds = {}));
//# sourceMappingURL=cubejs.js.map